export default __webpack_public_path__ + "img/16ef8ef9b063839b616a7bde40c41258.svg";